import { computed, watch, type Ref } from 'vue';
import type { MapBasemapMode, MapProvider } from '@gpx-spa/geo-domain';
import { useMapBasemapModeStore } from '@/stores/useMapBasemapModeStore';

/**
 * Global Map / Satellite preference (Pinia + IndexedDB), synced to a map provider when ready.
 */
export function usePersistedMapBasemap(
  mapProvider: MapProvider,
  mapReady: Ref<boolean>,
) {
  const store = useMapBasemapModeStore();
  void store.hydrateFromBrowserDb();

  const basemapMode = computed({
    get: (): MapBasemapMode => store.basemapMode,
    set: (mode: MapBasemapMode) => store.setBasemapMode(mode),
  });

  watch(
    () => [store.basemapMode, mapReady.value] as const,
    ([mode, ready]) => {
      if (!ready) {
        return;
      }
      if (mapProvider.getBasemapMode() !== mode) {
        mapProvider.setBasemapMode(mode);
      }
    },
    { immediate: true },
  );

  return { basemapMode };
}
